module.exports = __webpack_public_path__ + "img/Lorinthe-Logo-semi-transparant.1543242c.svg";